'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var clsx = require('clsx');
var nthHookTheme = require('@narvar/nth-hook-theme');
var BlockButton_module = require('./BlockButton.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);
var clsx__default = /*#__PURE__*/_interopDefaultLegacy(clsx);

let ButtonType = /*#__PURE__*/function (ButtonType) {
  ButtonType["button"] = "button";
  ButtonType["submit"] = "submit";
  return ButtonType;
}({});
let ButtonTargetType = /*#__PURE__*/function (ButtonTargetType) {
  ButtonTargetType["self"] = "_self";
  ButtonTargetType["blank"] = "_blank";
  return ButtonTargetType;
}({});
const Button = _ref => {
  let {
    onClick,
    href,
    target,
    type = ButtonType.button,
    big,
    disabled,
    outline,
    children,
    className = ''
  } = _ref;
  const [isHover, setIsHover] = React__namespace.useState(false);
  const handleMouseEnter = () => {
    setIsHover(true);
  };
  const handleMouseLeave = () => {
    setIsHover(false);
  };
  const {
    buttonsPrimaryDefault: buttonStyleDefault,
    buttonsPrimaryDisabled: buttonStyleDisabled,
    buttonsPrimaryHover: buttonStyleHover,
    buttonsSecondaryDefault: outlineStyleDefault,
    buttonsSecondaryDisabled: outlineStyleDisabled,
    buttonsSecondaryHover: outlineStyleHover
  } = nthHookTheme.useTheme();
  const sPrimary = {
    ...buttonStyleDefault,
    ...(isHover ? buttonStyleHover : {}),
    ...(disabled ? buttonStyleDisabled : {})
  };
  const sOutline = {
    ...outlineStyleDefault,
    ...(isHover ? outlineStyleHover : {}),
    ...(disabled ? outlineStyleDisabled : {})
  };
  const classes = clsx__default["default"]({
    [className]: !!className,
    [BlockButton_module["default"].button]: true,
    [BlockButton_module["default"].buttonNormal]: !outline,
    [BlockButton_module["default"].buttonOutline]: outline
  });
  const button = /*#__PURE__*/React__namespace.createElement("button", {
    style: {
      ...(outline ? sOutline : sPrimary),
      width: big ? '100%' : 'auto'
    },
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    disabled: disabled,
    onClick: href || disabled ? undefined : onClick,
    type: href ? undefined : type,
    className: classes
  }, children);
  if (href) {
    return /*#__PURE__*/React__namespace.createElement("a", {
      href: href,
      target: target || ButtonTargetType.blank,
      rel: "noreferrer noopener",
      onClick: onClick
    }, button);
  }
  return button;
};
var BlockButton = nthHookTheme.withThemeProvider(Button, {
  themeTokens: ['buttonsPrimaryDefault', 'buttonsPrimaryDisabled', 'buttonsPrimaryHover', 'buttonsSecondaryDefault', 'buttonsSecondaryDisabled', 'buttonsSecondaryHover']
});

exports.ButtonTargetType = ButtonTargetType;
exports.ButtonType = ButtonType;
exports["default"] = BlockButton;
